import React, { useEffect, useState } from "react";
import { Input, Table, Avatar, Button } from "antd";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { FilePdfOutlined } from "@ant-design/icons";

import ActionButtons from "../ActionButtons/ActionButtons";

const { Search } = Input;

const OfferResponses = ({ actions, state }) => {
  const { offerResponses } = state;

  const navigate = useNavigate();
  const [searchOffer, setSearchOffer] = useState("");
  const [selectedOffer, setSelectedOffer] = useState(null);

  useEffect(() => {
    actions.getOfferResponses();
  }, [actions]);

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedOffer(selectedRows);
    },
  };

  const navigateToDetails = () => {
    if (!selectedOffer) {
      return;
    }
    navigate(`/offer-request/${selectedOffer[0].key}/responses`);
  };

  const handleDeleteOffer = () => {
    if (!selectedOffer) {
      return;
    }

    const offerIds = selectedOffer.map((offer) => offer.key);
    actions.deleteOfferResponse(offerIds);
    setSelectedOffer(null);
  };

  const pdfExport = (id) => {
    actions.exportPdf(id);
  };

  const offerResponeColumns = (searchOffer, exportPdf) => {
    const columns = [
      {
        title: "NASLOV",
        dataIndex: "name",
        render: (text) => (
          <a className="text-light-blue cursor-default">{text}</a>
        ),
        filteredValue: [searchOffer],
        onFilter: (value, record) => {
          return record?.name
            .toLowerCase()
            .includes(searchOffer?.toLowerCase());
        },
      },
      {
        title: "Naziv klijenta",
        dataIndex: "client",
      },
      {
        title: <div className="text-center">Broj kreiranih ponuda</div>,
        width: 140,
        responsive: ["md"],
        render: (record) => (
          <div className="text-center">
            <Avatar className="bg-light-blue-login font-bold" size="small">
              {record.offerResponse.length}
            </Avatar>
          </div>
        ),
      },
      {
        title: <div className="text-center">Izvezi u PDF</div>,
        responsive: ["sm"],
        width: 120,
        render: (record) => (
          <div className="text-center mt-[2px]">
            <FilePdfOutlined
              className="text-2xl"
              onClick={() => exportPdf(record.key)}
            />
          </div>
        ),
      },
      {
        title: "Datum zadnje izmjene",
        dataIndex: "lastUpdate",
        responsive: ["lg"],
        width: 190,
        sorter: (a, b) => moment(a.lastUpdate).diff(moment(b.lastUpdate)),
      },
    ];

    return columns;
  };

  return (
    <div className="p-4">
      <div className="lg:flex justify-between mb-4">
        <div className="sm:flex justify-between w-full">
          <ActionButtons
            navigateToDetails={navigateToDetails}
            handleDelete={handleDeleteOffer}
            selectedUser={selectedOffer}
          />
        </div>

        <Search
          className="bg-light-blue lg:w-[450px] rounded-l-md rounded-r-sm mt-4 lg:mt-0"
          placeholder="Traži po nazivu zahtjeva za ponudu"
          onSearch={(e) => setSearchOffer(e)}
          enterButton
        />
      </div>
      <Table
        columns={offerResponeColumns(searchOffer, pdfExport)}
        dataSource={offerResponses}
        rowSelection={{
          ...rowSelection,
        }}
      />
    </div>
  );
};

export default OfferResponses;
